import React, { useEffect, useState } from 'react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { useTenant } from '../../context/TenantContext';
import api from '../../utils/api';
import { toast } from 'sonner';

const CierreMensual = () => {
  const { activeTenant } = useTenant();
  const [requests, setRequests] = useState([]);

  const loadRequests = async () => {
    if (!activeTenant) return;
    try {
      const res = await api.get(`/requests/tenant/${activeTenant}?request_type=cierre_mensual`);
      setRequests(res.data || []);
    } catch (error) {
      toast.error('Error al cargar cierres');
    }
  };

  useEffect(() => {
    loadRequests();
  }, [activeTenant]);

  return (
    <div className="max-w-5xl mx-auto" data-testid="client-cierre-page">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div>
          <h1 className="text-4xl font-heading font-bold">Cierre Mensual</h1>
          <p className="text-muted-foreground">Solicitudes de cierre y estado del periodo.</p>
        </div>
        <Button onClick={() => window.location.assign('/client/requests/new?type=cierre_mensual')}>
          Nuevo cierre
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Historial de cierres</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {requests.length === 0 ? (
            <div className="px-6 py-6 text-sm text-muted-foreground">No hay cierres registrados.</div>
          ) : (
            requests.map((req) => (
              <div key={req.id} className="flex items-center justify-between px-6 py-4 border-b last:border-b-0">
                <div>
                  <div className="font-medium">{req.title || req.request_type_name}</div>
                  <div className="text-xs text-muted-foreground">{req.created_at?.split('T')[0]}</div>
                </div>
                <span className="text-xs text-muted-foreground">{req.status}</span>
              </div>
            ))
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default CierreMensual;
